/* eslint-disable no-param-reassign */
import produce from 'immer';
import {
  SET_CUSTOMERS,
  GET_CUSTOMERS,
  GET_CUSTOMERS_SUCCESS,
  GET_CUSTOMERS_ERROR,
  SET_CUSTOMERS_QUERY,
  CLEAR_CUSTOMERS_QUERY_FILTER,
  GET_PURCHASED_PARTY_OPTIONS,
  GET_PURCHASED_PARTY_OPTIONS_SUCCESS,
  GET_PURCHASED_PARTY_OPTIONS_ERROR,
  GET_COMPANY_OPTIONS,
  GET_COMPANY_OPTIONS_SUCCESS,
  GET_COMPANY_OPTIONS_ERROR,
  SET_SELECTED_CUSTOMERS,
  SET_VISIBLE_MODAL_FORM_NUMBER,
  SET_VALUES_FORM_SEND_TEXT,
  SEND_TEXT_MESSAGE,
  SEND_TEXT_MESSAGE_ERROR,
  SEND_TEXT_MESSAGE_SUCCESS,
  SET_VALUES_FORM_ADD_PB_TAG,
  SET_VALUES_FORM_ADD_TO_PARTY,
  SEND_ADD_PARTY_GUESTS,
  SEND_ADD_PARTY_GUESTS_ERROR,
  SEND_ADD_PARTY_GUESTS_SUCCESS,
  SET_VALUES_FORM_ADD_TO_GROUP,
  SEND_ADD_GROUP_MEMBERS,
  SEND_ADD_GROUP_MEMBERS_ERROR,
  SEND_ADD_GROUP_MEMBERS_SUCCESS,
  SET_VALUES_FORM_REMOVE_FROM_GROUP,
  SEND_REMOVE_CONTACTS_FROM_GROUP,
  SEND_REMOVE_CONTACTS_FROM_GROUP_ERROR,
  SEND_REMOVE_CONTACTS_FROM_GROUP_SUCCESS,
  SET_VALUES_FORM_DO_NOT_EXECUTE_SMART_ACTIONS,
  SEND_DO_NOT_EXECUTE_SMART_ACTIONS,
  SEND_DO_NOT_EXECUTE_SMART_ACTIONS_ERROR,
  SEND_DO_NOT_EXECUTE_SMART_ACTIONS_SUCCESS,
  SEND_BULK_BIRTHDAY_UPDATE,
  SEND_BULK_BIRTHDAY_UPDATE_ERROR,
  SEND_BULK_BIRTHDAY_UPDATE_SUCCESS,
  SEND_BULK_MODIFY_CONTACTS,
  SEND_BULK_MODIFY_CONTACTS_ERROR,
  SEND_BULK_MODIFY_CONTACTS_SUCCESS,
  GET_MERGE_CONTACTS_PREVIEW,
  GET_MERGE_CONTACTS_PREVIEW_SUCCESS,
  GET_MERGE_CONTACTS_PREVIEW_ERROR,
  CLEAR_MERGE_CONTACTS_PREVIEW,
  SEND_MERGE_CONTACTS,
  SEND_MERGE_CONTACTS_SUCCESS,
  SEND_MERGE_CONTACTS_ERROR,
  GET_MERGE_HISTORY,
  GET_MERGE_HISTORY_SUCCESS,
  GET_MERGE_HISTORY_ERROR,
  SEND_UNDO_MERGE,
  SEND_UNDO_MERGE_SUCCESS,
  SEND_UNDO_MERGE_ERROR,
  GET_BULK_MERGE_USERS,
  GET_BULK_MERGE_USERS_SUCCESS,
  GET_BULK_MERGE_USERS_ERROR,
  SEND_ADD_TAG_CAMPAIGN,
  SEND_ADD_TAG_CAMPAIGN_ERROR,
  SEND_ADD_TAG_CAMPAIGN_SUCCESS,
  GET_FOLLOW_UP_MESSAGES,
  GET_FOLLOW_UP_MESSAGES_SUCCESS,
  GET_FOLLOW_UP_MESSAGES_ERROR,
  GET_PARTIES_LIST,
  GET_PARTIES_LIST_SUCCESS,
  GET_PARTIES_LIST_ERROR,
  REPLACE_SYSTEM_GEN_MESSAGE,
  REPLACE_SYSTEM_GEN_MESSAGE_SUCCESS,
  REPLACE_SYSTEM_GEN_MESSAGE_ERROR,
  SET_BACK_TO_CUSTOMER_LIST,
  SET_BACK_TO_PARTY_GUEST_LIST,
  SET_BACK_TO_GROUP_MEMBERS_LIST,
  SET_BACK_TO_CHATS_LIST,
  GET_PARTY_GUEST,
  GET_PARTY_GUEST_SUCCESS,
  GET_PARTY_GUEST_ERROR,
  GET_GROUP_MEMBER,
  GET_GROUP_MEMBER_SUCCESS,
  GET_GROUP_MEMBER_ERROR,
  UPLOAD_CSV_FOR_PARSING,
  UPLOAD_CSV_FOR_PARSING_SUCCESS,
  UPLOAD_CSV_FOR_PARSING_ERROR,
  IMPORT_CUSTOMERS_FROM_CSV,
  IMPORT_CUSTOMERS_FROM_CSV_SUCCESS,
  IMPORT_CUSTOMERS_FROM_CSV_ERROR,
  IMPORT_CUSTOMERS_FROM_CSV_LARGE,
  IMPORT_CUSTOMERS_FROM_CSV_LARGE_SUCCESS,
  IMPORT_CUSTOMERS_FROM_CSV_LARGE_ERROR,
  GET_IMPORT_BATCH_STATUS_SUCCESS,
  REVERT_IMPORT_BATCH_LARGE,
  REVERT_IMPORT_BATCH_LARGE_SUCCESS,
  REVERT_IMPORT_BATCH_LARGE_ERROR,
  CLEAR_IMPORT_STATE,
  SET_ACTIVE_IMPORT,
  UPLOAD_CSV_FOR_PARSING_V2,
  UPLOAD_CSV_FOR_PARSING_V2_SUCCESS,
  UPLOAD_CSV_FOR_PARSING_V2_ERROR,
  IMPORT_CUSTOMERS_FROM_CSV_V2,
  IMPORT_CUSTOMERS_FROM_CSV_V2_SUCCESS,
  IMPORT_CUSTOMERS_FROM_CSV_V2_ERROR,
  CLEAR_IMPORT_V2_STATE,
  GET_IMPORT_BATCHES,
  GET_IMPORT_BATCHES_SUCCESS,
  GET_IMPORT_BATCHES_ERROR,
  SET_IMPORT_LOG_ENTRIES,
  GET_IMPORT_LOG_ENTRIES,
  GET_IMPORT_LOG_ENTRIES_SUCCESS,
  GET_IMPORT_LOG_ENTRIES_ERROR,
  SET_IMPORT_LOG_ENTRIES_QUERY,
  GET_IMPORT_LOG_ENTRIES_COUNTS,
  GET_IMPORT_LOG_ENTRIES_COUNTS_SUCCESS,
  GET_IMPORT_LOG_ENTRIES_COUNTS_ERROR,
  REVERT_IMPORT_LOG_ENTRIES,
  REVERT_IMPORT_LOG_ENTRIES_SUCCESS,
  REVERT_IMPORT_LOG_ENTRIES_ERROR,
  CLEAR_IMPORT_LOG_ENTRIES_QUERY_FILTER,
  SET_BACK_TO_IMPORT_LOG_ENTRIES_LIST,
  SET_SELECTED_IMPORT_LOG_ENTRIES,
  SET_VISIBLE_MODAL_FORM_NUMBER_IMPORT_HISTORY,
  SET_VISIBLE_FILTER_DROPDOWN,
} from 'src/actions/customersActions';

const initialFilters = {
  phone1Valid: null, // null (any), 'valid', 'invalid'
  phone1Textable: null, // null (any), 'textable', 'notTextable'
  type: null,
  isACustomer: 'either', // 'either', true, false
  doNotText: 'either', // 'either', true, false
  categories: [],
  categoriesExclude: [], // categories to exclude
  // TODO: Groups fields (commented out for future use)
  // groupsInclude: [], // Groups that contacts are IN
  // groupsExclude: [], // Groups that contacts are NOT IN
  typePurchase: null,
  purchasedParty: null,
  purchasedPartyList: [],
  typePurchaseDateFrom: null,
  typePurchaseDateTo: null,
  firstPurchaseDateFrom: null,
  firstPurchaseDateTo: null,
  lastPurchaseDateFrom: null,
  lastPurchaseDateTo: null,
  birthdayDayFrom: null,
  birthdayDayTo: null,
  birthdayMonthFrom: null,
  birthdayMonthTo: null,
  birthdayYearFrom: null,
  birthdayYearTo: null,
  // Events filter fields
  eventsIncludeMode: null,
  eventsIncludeSpecific: [],
  eventsIncludeDateFrom: null,
  eventsIncludeDateTo: null,
  eventsIncludeHosts: true,
  eventsIncludeGuests: true,
  eventsExcludeMode: null,
  eventsExcludeSpecific: [],
  eventsExcludeDateFrom: null,
  eventsExcludeDateTo: null,
  eventsExcludeHosts: true,
  eventsExcludeGuests: true,
  // CON-1474: Filter By Smart Fields. Each entry:
  // { fieldKey, operator, value, valueFrom, valueTo }. No fieldType —
  // the backend resolves it authoritatively from the salesperson's
  // smartFieldDefinitions. 'Active'/'Inactive' is a UI-only split; the
  // backend flattens both arrays and AND-combines them. Reset is
  // automatic via CLEAR_CUSTOMERS_QUERY_FILTER (draft.query.filters =
  // initialFilters).
  activeSmartFields: [],
  inactiveSmartFields: [],
};

const formSendText = {
  systemGenMessageReplaced: false,
  attachment: false,
  attachmentContainer: null,
  loading: false,
};

const formAddPBTag = {
  loading: false,
};

const formAddToParty = {
  loading: false,
  party: '',
};

const formAddToGroup = {
  loading: false,
  group: '',
};

const formRemoveFromGroup = {
  loading: false,
  group: '',
};

const formDoNotExecuteSmartActions = {
  loading: false,
  group: '',
};

const formModifyBirthdays = {
  loading: false,
};

const formModifyContacts = {
  loading: false,
};

const formMergeContacts = {
  loading: false,
  merging: false,
  preview: null,
  previewError: null,
  mergeError: null,
  latestRequestId: 0,
};

const formMergeHistory = {
  list: [],
  loading: false,
  error: null,
  undoing: false,
};

const followUpMessages = {
  followUpMessageList: [],
  loading: false,
};

const backToCustomerList = {
  customers: [],
  query: {},
  active: false,
  comeBack: false,
  filterByInUrl: {},
};

const backToPartyGuestList = {
  partyId: null,
  partyGuest: {},
  partyName: '',
  active: false,
  comeBack: false,
  backToId: null,
  startPartyGuestFromId: null,
  initScrollToId: false,
};
const backToGroupMembersList = {
  groupId: null,
  groupMember: {},
  groupName: '',
  active: false,
  comeBack: false,
  backToId: null,
  startGroupMemberFromId: null,
  initScrollToId: false,
};

const backToChatsList = {
  active: false,
  comeBack: false,
};

const customersImport = {
  attachedFile: {
    fileName: '',
    fileContent: [],
  },
  parsedFile: {
    numberOfContacts: 0,
    matchedColumnsMap: {},
    uploadedFileHeaders: [],
    columns: {
      fieldsWithoutSection: [],
      sections: [],
    },
  },
  importResults: {
    created: [],
    updated: [],
    skipped: [],
    pbImportUsed: false,
  },
  loading: false,
};

const customersImportV2 = {
  attachedFile: {
    fileName: '',
    fileContent: [],
  },
  parsedFile: {
    numberOfContacts: 0,
    matchedColumnsMap: {},
    uploadedFileHeaders: [],
    columns: {
      fieldsWithoutSection: [],
      sections: [],
    },
  },
  contactSmartFieldDefinitions: [],
  inactiveContactSmartFieldDefinitions: [],
  smartFieldAutoMatches: {},
  templateDetection: {
    templates: [],
    bestTemplateId: null,
  },
  loading: false,
};

const backToImportLogEntries = {
  importLogEntries: [],
  query: {},
  active: false,
  comeBack: false,
};

const contactImportHistory = {
  importBatches: [],
  importLogEntries: [],
  selectedImportLogEntries: [],
  query: {
    search: '',
    // filters: initialFilters,
    importBatchId: null,
    status: 'skipped',
    sort: [],
    page: 1,
    pageSize: 100,
    count: 0,
  },
  importResultsCount: {
    created: 0,
    updated: 0,
    skipped: 0,
    reverted: 0,
  },
  visibleModalFormNumber: null,
  // formAddPBTag,
  backToImportLogEntries,
  loadingImportLogEntries: false,
  loadingImportBatches: false,
  loadingRevertImportLogEntries: false,
  loadingImportLogEntriesCounts: false,
};

// CON-1459: Active background import tracking
const activeImport = {
  importBatchId: null,
  status: null,
  totalRows: 0,
  processedRows: 0,
};

// CON-1460: Active background revert tracking
const activeRevert = {
  importBatchId: null,
  revertStatus: null,
  totalRows: 0,
  revertedRows: 0,
};

const initialState = {
  customers: [],
  // CON-1532 — V2 Contacts page column config (set by GET_CUSTOMERS_SUCCESS).
  customersColumnConfig: null,
  customersImport,
  customersImportV2,
  activeImport,
  activeRevert,
  contactImportHistory,
  selectedCustomers: [],
  query: {
    search: '',
    filters: initialFilters,
    sort: [],
    page: 1,
    pageSize: 50,
    count: 0,
  },
  purchasedPartyOptions: {
    data: [],
    loading: false,
  },
  companyOptions: {
    data: [],
    loading: false,
  },
  parties: [],
  partiesLoading: false,
  visibleModalFormNumber: null,
  formSendText,
  formAddPBTag,
  formAddToParty,
  formAddToGroup,
  formRemoveFromGroup,
  formDoNotExecuteSmartActions,
  formModifyBirthdays,
  formModifyContacts,
  formMergeContacts,
  formMergeHistory,
  bulkMergeUsers: {
    loading: false,
    users: [],
    error: null,
  },
  followUpMessages,
  backToCustomerList,
  backToPartyGuestList,
  backToGroupMembersList,
  backToChatsList,
  loading: false,
  visibleFilterDropdown: false,
};

const customersReducer = (state = initialState, action) => {
  const { type, payload } = action;
  switch (type) {
    case SET_CUSTOMERS: {
      return produce(state, (draft) => {
        draft.customers = payload || [];
      });
    }

    case GET_CUSTOMERS: {
      return produce(state, (draft) => {
        draft.loading = true;
      });
    }

    case GET_CUSTOMERS_SUCCESS: {
      return produce(state, (draft) => {
        draft.customers = payload?.contacts || [];
        draft.query.count = payload?.count || 0;
        // CON-1532 — V2 Contacts page column config. V1 ignores it.
        draft.customersColumnConfig = payload?.columnConfig || null;
        draft.loading = false;
      });
    }

    case GET_CUSTOMERS_ERROR: {
      return produce(state, (draft) => {
        draft.loading = false;
      });
    }

    case UPLOAD_CSV_FOR_PARSING: {
      return produce(state, (draft) => {
        draft.customersImport.loading = true;
      });
    }

    case UPLOAD_CSV_FOR_PARSING_SUCCESS: {
      return produce(state, (draft) => {
        draft.customersImport.loading = false;
        draft.customersImport.attachedFile.fileName = payload?.fileName || '';
        draft.customersImport.attachedFile.fileContent = payload?.fileContent || [];
        draft.customersImport.parsedFile = payload?.data;
        // Strip empty-string headers to prevent duplicate empty options in dropdowns
        if (Array.isArray(draft.customersImport.parsedFile?.uploadedFileHeaders)) {
          draft.customersImport.parsedFile.uploadedFileHeaders = draft.customersImport.parsedFile.uploadedFileHeaders.filter(
            (header) => header && header.trim() !== ''
          );
        }
        draft.customersImport.parsedFile.columns.fieldsWithoutSection = payload?.data?.columns?.fieldsWithoutSection?.filter(
          (field) => field === 'type' || field === 'companyContactId'
        );
      });
    }

    case UPLOAD_CSV_FOR_PARSING_ERROR: {
      return produce(state, (draft) => {
        draft.customersImport.loading = false;
        draft.customersImport = initialState.customersImport;
      });
    }

    case IMPORT_CUSTOMERS_FROM_CSV: {
      return produce(state, (draft) => {
        draft.customersImport.loading = true;
      });
    }

    case IMPORT_CUSTOMERS_FROM_CSV_SUCCESS: {
      return produce(state, (draft) => {
        draft.customersImport.importResults = payload?.data || initialState.customersImport.importResults;
        draft.customersImport.loading = false;
      });
    }

    case IMPORT_CUSTOMERS_FROM_CSV_ERROR: {
      return produce(state, (draft) => {
        draft.customersImport.loading = false;
      });
    }

    case CLEAR_IMPORT_STATE: {
      return produce(state, (draft) => {
        draft.customersImport.loading = false;
        draft.customersImport = initialState.customersImport;
      });
    }

    // V2 Import reducer cases
    case UPLOAD_CSV_FOR_PARSING_V2: {
      return produce(state, (draft) => {
        draft.customersImportV2.loading = true;
      });
    }

    case UPLOAD_CSV_FOR_PARSING_V2_SUCCESS: {
      const { fileName, fileContent, data } = payload || {};
      return produce(state, (draft) => {
        draft.customersImportV2.attachedFile = { fileName, fileContent };
        draft.customersImportV2.parsedFile = {
          numberOfContacts: data?.numberOfContacts || 0,
          matchedColumnsMap: data?.matchedColumnsMap || {},
          uploadedFileHeaders: (data?.uploadedFileHeaders || []).filter(Boolean),
          columns: {
            fieldsWithoutSection: (data?.columns?.fieldsWithoutSection || [])
              .filter((f) => f === 'type' || f === 'companyContactId'),
            sections: data?.columns?.sections || [],
          },
        };
        draft.customersImportV2.contactSmartFieldDefinitions = data?.contactSmartFieldDefinitions || [];
        draft.customersImportV2.inactiveContactSmartFieldDefinitions = data?.inactiveContactSmartFieldDefinitions || [];
        draft.customersImportV2.smartFieldAutoMatches = data?.smartFieldAutoMatches || {};
        draft.customersImportV2.templateDetection = {
          templates: data?.templateDetection?.templates || [],
          bestTemplateId: data?.templateDetection?.bestTemplateId || null,
        };
        draft.customersImportV2.loading = false;
      });
    }

    case UPLOAD_CSV_FOR_PARSING_V2_ERROR: {
      return produce(state, (draft) => {
        draft.customersImportV2.loading = false;
      });
    }

    case IMPORT_CUSTOMERS_FROM_CSV_V2: {
      return produce(state, (draft) => {
        draft.customersImportV2.loading = true;
      });
    }

    case IMPORT_CUSTOMERS_FROM_CSV_V2_SUCCESS: {
      const { importBatchId, status, totalRows } = payload || {};
      return produce(state, (draft) => {
        draft.customersImportV2.loading = false;
        // A V2 import the server queued for background processing has to
        // populate activeImport, or the progress banner stays blind until
        // something remounts and re-runs checkActiveImport — which is why
        // it only appeared after a manual browser refresh. The
        // redirectedToBackground responses dispatch
        // IMPORT_CUSTOMERS_FROM_CSV_LARGE_SUCCESS instead, but a response
        // that carries a batch id and a still-running status belongs here
        // too. A finished synchronous import has neither, so it no-ops.
        if (importBatchId && (status === 'queued' || status === 'processing')) {
          draft.activeImport = {
            importBatchId,
            status,
            totalRows: totalRows || 0,
            processedRows: 0,
          };
        }
      });
    }

    case IMPORT_CUSTOMERS_FROM_CSV_V2_ERROR: {
      return produce(state, (draft) => {
        draft.customersImportV2.loading = false;
      });
    }

    case CLEAR_IMPORT_V2_STATE: {
      return produce(state, (draft) => {
        draft.customersImportV2 = initialState.customersImportV2;
      });
    }

    // CON-1459: Bootstrap activeImport/activeRevert from server on mount
    case SET_ACTIVE_IMPORT: {
      const { importBatchId, status } = payload || {};
      if (!importBatchId) return state;
      return produce(state, (draft) => {
        if (status === 'reverting') {
          draft.activeRevert = {
            importBatchId,
            revertStatus: 'processing',
            totalRows: 0,
            revertedRows: 0,
          };
        } else {
          draft.activeImport = {
            importBatchId,
            status: status || 'processing',
            totalRows: 0,
            processedRows: 0,
          };
        }
      });
    }

    // CON-1459: Large CSV background import
    case IMPORT_CUSTOMERS_FROM_CSV_LARGE: {
      return produce(state, (draft) => {
        draft.customersImport.loading = true;
      });
    }

    case IMPORT_CUSTOMERS_FROM_CSV_LARGE_SUCCESS: {
      const {
        importBatchId, status, totalRows,
      } = payload;
      return produce(state, (draft) => {
        draft.customersImport.loading = false;
        draft.activeImport = {
          importBatchId,
          status: status || 'queued',
          totalRows: totalRows || 0,
          processedRows: 0,
        };
      });
    }

    case IMPORT_CUSTOMERS_FROM_CSV_LARGE_ERROR: {
      return produce(state, (draft) => {
        draft.customersImport.loading = false;
      });
    }

    case GET_IMPORT_BATCH_STATUS_SUCCESS: {
      const batch = payload?.importBatch || payload;
      return produce(state, (draft) => {
        if (batch?.id && draft.activeImport.importBatchId === batch.id) {
          draft.activeImport.status = batch.status;
          draft.activeImport.processedRows = batch.processedRows || 0;
          draft.activeImport.totalRows = batch.totalRows || 0;
        }
        // CON-1460: Also update activeRevert when polling returns revert info
        if (batch?.id && draft.activeRevert.importBatchId === batch.id) {
          draft.activeRevert.revertStatus = batch.revertStatus;
          draft.activeRevert.revertedRows = batch.revertedRows || 0;
          draft.activeRevert.totalRows = batch.totalRows || 0;
        }
        // CON-1459: Update matching importBatches entry in-place so the
        // batch selector dropdown shows live status/progress labels.
        // Only update fields available from the polling response —
        // entryCount is a SQL aggregate and requires a full refresh.
        if (batch?.id) {
          const batches = draft.contactImportHistory?.importBatches;
          if (batches) {
            const idx = batches.findIndex((b) => b.id === batch.id);
            if (idx !== -1) {
              batches[idx].status = batch.status;
              batches[idx].processedRows = batch.processedRows || 0;
              batches[idx].totalRows = batch.totalRows || 0;
              batches[idx].revertStatus = batch.revertStatus;
              batches[idx].revertedRows = batch.revertedRows || 0;
            }
          }
        }
      });
    }

    // CON-1460: Background revert cases
    case REVERT_IMPORT_BATCH_LARGE: {
      return state;
    }

    case REVERT_IMPORT_BATCH_LARGE_SUCCESS: {
      const {
        importBatchId: revertBatchId,
        revertStatus: newRevertStatus,
      } = payload || {};
      return produce(state, (draft) => {
        draft.activeRevert = {
          importBatchId: revertBatchId || null,
          revertStatus: newRevertStatus || 'queued',
          totalRows: 0,
          revertedRows: 0,
        };
      });
    }

    case REVERT_IMPORT_BATCH_LARGE_ERROR: {
      return state;
    }

    case SET_CUSTOMERS_QUERY: {
      return produce(state, (draft) => {
        draft.query = payload ? {
          ...state.query,
          ...payload
        } : initialState.query;
      });
    }

    case CLEAR_CUSTOMERS_QUERY_FILTER: {
      return produce(state, (draft) => {
        draft.query.filters = initialFilters;
        draft.query.page = initialState.query.page;
      });
    }

    case GET_PURCHASED_PARTY_OPTIONS: {
      return produce(state, (draft) => {
        draft.purchasedPartyOptions.loading = true;
        draft.purchasedPartyOptions.data = [];
      });
    }

    case GET_PURCHASED_PARTY_OPTIONS_SUCCESS: {
      return produce(state, (draft) => {
        draft.purchasedPartyOptions.loading = false;
        draft.purchasedPartyOptions.data = payload || [];
      });
    }

    case GET_PURCHASED_PARTY_OPTIONS_ERROR: {
      return produce(state, (draft) => {
        draft.purchasedPartyOptions.loading = false;
      });
    }

    case GET_COMPANY_OPTIONS: {
      return produce(state, (draft) => {
        draft.companyOptions.loading = true;
        draft.companyOptions.data = [];
      });
    }

    case GET_COMPANY_OPTIONS_SUCCESS: {
      return produce(state, (draft) => {
        draft.companyOptions.loading = false;
        draft.companyOptions.data = payload || [];
      });
    }

    case GET_COMPANY_OPTIONS_ERROR: {
      return produce(state, (draft) => {
        draft.companyOptions.loading = false;
      });
    }

    case SET_SELECTED_CUSTOMERS: {
      return produce(state, (draft) => {
        draft.selectedCustomers = payload || [];
      });
    }

    case SET_VISIBLE_MODAL_FORM_NUMBER: {
      return produce(state, (draft) => {
        draft.visibleModalFormNumber = payload || null;
      });
    }

    case SET_VALUES_FORM_SEND_TEXT: {
      return produce(state, (draft) => {
        draft.formSendText = payload ? {
          ...state.formSendText,
          ...payload,
        } : formSendText;
      });
    }

    case SEND_TEXT_MESSAGE: {
      return produce(state, (draft) => {
        draft.formSendText.loading = true;
      });
    }

    case SEND_TEXT_MESSAGE_SUCCESS:
    case SEND_TEXT_MESSAGE_ERROR: {
      return produce(state, (draft) => {
        draft.formSendText.loading = false;
      });
    }

    case SET_VALUES_FORM_ADD_PB_TAG: {
      return produce(state, (draft) => {
        draft.formAddPBTag = payload ? {
          ...state.formAddPBTag,
          ...payload,
        } : formAddPBTag;
      });
    }

    case SET_VALUES_FORM_ADD_TO_PARTY: {
      return produce(state, (draft) => {
        draft.formAddToParty = payload ? {
          ...state.formAddToParty,
          ...payload,
        } : formAddToParty;
      });
    }

    case SEND_ADD_PARTY_GUESTS: {
      return produce(state, (draft) => {
        draft.formAddToParty.loading = true;
      });
    }

    case SEND_ADD_PARTY_GUESTS_SUCCESS:
    case SEND_ADD_PARTY_GUESTS_ERROR: {
      return produce(state, (draft) => {
        draft.formAddToParty.loading = false;
      });
    }

    case SET_VALUES_FORM_ADD_TO_GROUP: {
      return produce(state, (draft) => {
        draft.formAddToGroup = payload ? {
          ...state.formAddToGroup,
          ...payload,
        } : formAddToGroup;
      });
    }

    case SEND_ADD_GROUP_MEMBERS: {
      return produce(state, (draft) => {
        draft.formAddToGroup.loading = true;
      });
    }

    case SEND_ADD_GROUP_MEMBERS_SUCCESS:
    case SEND_ADD_GROUP_MEMBERS_ERROR: {
      return produce(state, (draft) => {
        draft.formAddToGroup.loading = false;
      });
    }

    case SET_VALUES_FORM_REMOVE_FROM_GROUP: {
      return produce(state, (draft) => {
        draft.formRemoveFromGroup = payload ? {
          ...state.formRemoveFromGroup,
          ...payload,
        } : formRemoveFromGroup;
      });
    }

    case SEND_REMOVE_CONTACTS_FROM_GROUP: {
      return produce(state, (draft) => {
        draft.formRemoveFromGroup.loading = true;
      });
    }

    case SEND_REMOVE_CONTACTS_FROM_GROUP_SUCCESS:
    case SEND_REMOVE_CONTACTS_FROM_GROUP_ERROR: {
      return produce(state, (draft) => {
        draft.formRemoveFromGroup.loading = false;
      });
    }

    case SET_VALUES_FORM_DO_NOT_EXECUTE_SMART_ACTIONS: {
      return produce(state, (draft) => {
        draft.formDoNotExecuteSmartActions = payload ? {
          ...state.formDoNotExecuteSmartActions,
          ...payload,
        } : formDoNotExecuteSmartActions;
      });
    }

    case SEND_DO_NOT_EXECUTE_SMART_ACTIONS: {
      return produce(state, (draft) => {
        draft.formDoNotExecuteSmartActions.loading = true;
      });
    }

    case SEND_DO_NOT_EXECUTE_SMART_ACTIONS_SUCCESS:
    case SEND_DO_NOT_EXECUTE_SMART_ACTIONS_ERROR: {
      return produce(state, (draft) => {
        draft.formDoNotExecuteSmartActions.loading = false;
      });
    }

    case SEND_BULK_BIRTHDAY_UPDATE: {
      return produce(state, (draft) => {
        draft.formModifyBirthdays.loading = true;
      });
    }

    case SEND_BULK_BIRTHDAY_UPDATE_SUCCESS:
    case SEND_BULK_BIRTHDAY_UPDATE_ERROR: {
      return produce(state, (draft) => {
        draft.formModifyBirthdays.loading = false;
      });
    }

    case SEND_BULK_MODIFY_CONTACTS: {
      return produce(state, (draft) => {
        draft.formModifyContacts.loading = true;
      });
    }

    case SEND_BULK_MODIFY_CONTACTS_SUCCESS:
    case SEND_BULK_MODIFY_CONTACTS_ERROR: {
      return produce(state, (draft) => {
        draft.formModifyContacts.loading = false;
      });
    }

    case GET_MERGE_CONTACTS_PREVIEW: {
      return produce(state, (draft) => {
        draft.formMergeContacts.loading = true;
        draft.formMergeContacts.previewError = null;
        draft.formMergeContacts.latestRequestId = (state.formMergeContacts?.latestRequestId || 0) + 1;
      });
    }

    case GET_MERGE_CONTACTS_PREVIEW_SUCCESS: {
      // Drop stale responses — only commit the most recent dispatch.
      if (payload?.requestId !== state.formMergeContacts?.latestRequestId) {
        return state;
      }
      return produce(state, (draft) => {
        draft.formMergeContacts.loading = false;
        draft.formMergeContacts.preview = payload?.preview || null;
        draft.formMergeContacts.previewError = null;
      });
    }

    case GET_MERGE_CONTACTS_PREVIEW_ERROR: {
      // Drop stale errors too — a newer request is in flight; its result
      // is the one we want to honor.
      if (payload?.requestId !== state.formMergeContacts?.latestRequestId) {
        return state;
      }
      return produce(state, (draft) => {
        draft.formMergeContacts.loading = false;
        draft.formMergeContacts.previewError = payload?.error || 'Could not load preview';
      });
    }

    case CLEAR_MERGE_CONTACTS_PREVIEW: {
      return produce(state, (draft) => {
        draft.formMergeContacts.preview = null;
        draft.formMergeContacts.previewError = null;
        draft.formMergeContacts.mergeError = null;
        draft.formMergeContacts.loading = false;
        draft.formMergeContacts.merging = false;
        draft.formMergeContacts.latestRequestId = 0;
      });
    }

    case SEND_MERGE_CONTACTS: {
      return produce(state, (draft) => {
        draft.formMergeContacts.merging = true;
        draft.formMergeContacts.mergeError = null;
      });
    }

    case SEND_MERGE_CONTACTS_SUCCESS: {
      return produce(state, (draft) => {
        draft.formMergeContacts.merging = false;
        draft.formMergeContacts.mergeError = null;
      });
    }

    case SEND_MERGE_CONTACTS_ERROR: {
      return produce(state, (draft) => {
        draft.formMergeContacts.merging = false;
        draft.formMergeContacts.mergeError = payload || 'Merge failed';
      });
    }

    case GET_MERGE_HISTORY: {
      return produce(state, (draft) => {
        draft.formMergeHistory.loading = true;
        draft.formMergeHistory.error = null;
      });
    }

    case GET_MERGE_HISTORY_SUCCESS: {
      return produce(state, (draft) => {
        draft.formMergeHistory.loading = false;
        draft.formMergeHistory.list = Array.isArray(payload) ? payload : [];
        draft.formMergeHistory.error = null;
      });
    }

    case GET_MERGE_HISTORY_ERROR: {
      return produce(state, (draft) => {
        draft.formMergeHistory.loading = false;
        draft.formMergeHistory.error = payload || 'Could not load merge history';
      });
    }

    case SEND_UNDO_MERGE: {
      return produce(state, (draft) => {
        draft.formMergeHistory.undoing = true;
      });
    }

    case SEND_UNDO_MERGE_SUCCESS:
    case SEND_UNDO_MERGE_ERROR: {
      return produce(state, (draft) => {
        draft.formMergeHistory.undoing = false;
      });
    }

    case GET_BULK_MERGE_USERS: {
      return produce(state, (draft) => {
        draft.bulkMergeUsers.loading = true;
        draft.bulkMergeUsers.error = null;
      });
    }

    case GET_BULK_MERGE_USERS_SUCCESS: {
      return produce(state, (draft) => {
        draft.bulkMergeUsers.loading = false;
        draft.bulkMergeUsers.users = payload || [];
      });
    }

    case GET_BULK_MERGE_USERS_ERROR: {
      return produce(state, (draft) => {
        draft.bulkMergeUsers.loading = false;
        draft.bulkMergeUsers.users = [];
        draft.bulkMergeUsers.error = payload || null;
      });
    }

    case SEND_ADD_TAG_CAMPAIGN: {
      return produce(state, (draft) => {
        draft.formAddPBTag.loading = true;
      });
    }

    case SEND_ADD_TAG_CAMPAIGN_SUCCESS:
    case SEND_ADD_TAG_CAMPAIGN_ERROR: {
      return produce(state, (draft) => {
        draft.formAddPBTag.loading = false;
      });
    }

    case GET_FOLLOW_UP_MESSAGES: {
      return produce(state, (draft) => {
        draft.followUpMessages.loading = true;
      });
    }

    case GET_FOLLOW_UP_MESSAGES_SUCCESS:
    case GET_FOLLOW_UP_MESSAGES_ERROR: {
      return produce(state, (draft) => {
        draft.followUpMessages.loading = false;
        draft.followUpMessages.followUpMessageList = payload ? [
          ...state.followUpMessages.followUpMessageList,
          ...payload,
        ] : followUpMessages.followUpMessageList;
      });
    }

    case GET_PARTIES_LIST: {
      return produce(state, (draft) => {
        draft.partiesLoading = true;
      });
    }

    case GET_PARTIES_LIST_SUCCESS: {
      return produce(state, (draft) => {
        draft.parties = payload || {};
        draft.partiesLoading = false;
      });
    }

    case GET_PARTIES_LIST_ERROR: {
      return produce(state, (draft) => {
        draft.partiesLoading = false;
      });
    }

    case REPLACE_SYSTEM_GEN_MESSAGE: {
      return produce(state, (draft) => {
        draft.formSendText.loading = true;
      });
    }

    case REPLACE_SYSTEM_GEN_MESSAGE_SUCCESS:
    case REPLACE_SYSTEM_GEN_MESSAGE_ERROR: {
      return produce(state, (draft) => {
        draft.formSendText.loading = false;
        draft.formSendText.systemGenMessageReplaced = payload || false;
      });
    }

    case SET_BACK_TO_CUSTOMER_LIST: {
      return produce(state, (draft) => {
        draft.backToCustomerList = payload ? {
          ...state.backToCustomerList,
          ...payload,
        } : backToCustomerList;
      });
    }

    case SET_BACK_TO_PARTY_GUEST_LIST: {
      return produce(state, (draft) => {
        draft.backToPartyGuestList = payload ? {
          ...state.backToPartyGuestList,
          ...payload,
        } : backToPartyGuestList;
      });
    }

    case SET_BACK_TO_GROUP_MEMBERS_LIST: {
      return produce(state, (draft) => {
        draft.backToGroupMembersList = payload ? {
          ...state.backToGroupMembersList,
          ...payload,
        } : backToGroupMembersList;
      });
    }

    case SET_BACK_TO_CHATS_LIST: {
      return produce(state, (draft) => {
        draft.backToChatsList = payload ? {
          ...state.backToChatsList,
          ...payload,
        } : backToChatsList;
      });
    }

    case GET_PARTY_GUEST: {
      return produce(state, (draft) => {
        draft.loading = true;
      });
    }

    case GET_PARTY_GUEST_SUCCESS: {
      return produce(state, (draft) => {
        draft.backToPartyGuestList.partyGuest = payload?.partyGuest || {};
        draft.loading = false;
      });
    }

    case GET_PARTY_GUEST_ERROR: {
      return produce(state, (draft) => {
        draft.loading = false;
      });
    }

    case GET_GROUP_MEMBER: {
      return produce(state, (draft) => {
        draft.loading = true;
      });
    }

    case GET_GROUP_MEMBER_SUCCESS: {
      return produce(state, (draft) => {
        draft.backToGroupMembersList.groupMember = payload || {};
        draft.loading = false;
      });
    }

    case GET_GROUP_MEMBER_ERROR: {
      return produce(state, (draft) => {
        draft.loading = false;
      });
    }

    case GET_IMPORT_BATCHES: {
      return produce(state, (draft) => {
        draft.contactImportHistory.loadingImportBatches = true;
      });
    }

    case GET_IMPORT_BATCHES_SUCCESS: {
      return produce(state, (draft) => {
        draft.contactImportHistory.importBatches = payload?.importBatches || [];
        draft.contactImportHistory.loadingImportBatches = false;
      });
    }

    case GET_IMPORT_BATCHES_ERROR: {
      return produce(state, (draft) => {
        draft.contactImportHistory.loadingImportBatches = false;
      });
    }

    case SET_IMPORT_LOG_ENTRIES: {
      return produce(state, (draft) => {
        draft.contactImportHistory.importLogEntries = payload || [];
        draft.contactImportHistory.selectedImportLogEntries = [];
      });
    }

    case GET_IMPORT_LOG_ENTRIES: {
      return produce(state, (draft) => {
        draft.contactImportHistory.loadingImportLogEntries = true;
      });
    }

    case GET_IMPORT_LOG_ENTRIES_SUCCESS: {
      return produce(state, (draft) => {
        draft.contactImportHistory.importLogEntries = payload?.importLogEntries || [];
        draft.contactImportHistory.query.count = payload?.count || 0;
        draft.contactImportHistory.loadingImportLogEntries = false;
        draft.contactImportHistory.selectedImportLogEntries = [];
      });
    }

    case GET_IMPORT_LOG_ENTRIES_ERROR: {
      return produce(state, (draft) => {
        draft.contactImportHistory.loadingImportLogEntries = false;
      });
    }

    case SET_IMPORT_LOG_ENTRIES_QUERY: {
      return produce(state, (draft) => {
        draft.contactImportHistory.query = payload ? {
          ...state.contactImportHistory.query,
          ...payload
        } : initialState.contactImportHistory.query;
      });
    }

    case CLEAR_IMPORT_LOG_ENTRIES_QUERY_FILTER: {
      return produce(state, (draft) => {
        // draft.query.filters = initialFilters;
        draft.contactImportHistory.query.page = initialState.contactImportHistory.query.page;
      });
    }

    case SET_SELECTED_IMPORT_LOG_ENTRIES: {
      return produce(state, (draft) => {
        draft.contactImportHistory.selectedImportLogEntries = payload || [];
      });
    }

    case GET_IMPORT_LOG_ENTRIES_COUNTS: {
      return produce(state, (draft) => {
        draft.contactImportHistory.loadingImportLogEntriesCounts = true;
      });
    }

    case GET_IMPORT_LOG_ENTRIES_COUNTS_SUCCESS: {
      return produce(state, (draft) => {
        draft.contactImportHistory.importResultsCount = payload?.importResultsCount || [];
        draft.contactImportHistory.loadingImportLogEntriesCounts = false;
      });
    }

    case GET_IMPORT_LOG_ENTRIES_COUNTS_ERROR: {
      return produce(state, (draft) => {
        draft.contactImportHistory.loadingImportLogEntriesCounts = false;
      });
    }

    case SET_VISIBLE_MODAL_FORM_NUMBER_IMPORT_HISTORY: {
      return produce(state, (draft) => {
        draft.contactImportHistory.visibleModalFormNumber = payload || null;
      });
    }

    case SET_BACK_TO_IMPORT_LOG_ENTRIES_LIST: {
      return produce(state, (draft) => {
        draft.contactImportHistory.backToImportLogEntries = payload ? {
          ...state.contactImportHistory.backToImportLogEntries,
          ...payload,
        } : contactImportHistory.backToImportLogEntries;
      });
    }

    case REVERT_IMPORT_LOG_ENTRIES: {
      return produce(state, (draft) => {
        draft.contactImportHistory.loadingRevertImportLogEntries = true;
      });
    }

    case REVERT_IMPORT_LOG_ENTRIES_SUCCESS:
    case REVERT_IMPORT_LOG_ENTRIES_ERROR: {
      return produce(state, (draft) => {
        draft.contactImportHistory.loadingRevertImportLogEntries = false;
      });
    }

    case SET_VISIBLE_FILTER_DROPDOWN: {
      return produce(state, (draft) => {
        draft.visibleFilterDropdown = payload || false;
      });
    }

    default: {
      return state;
    }
  }
};

export default customersReducer;
